import axios from 'axios';
import { getDomainConfig } from '../config/config';
import { addGeoParam } from '../utils/getURLParams';

const config = getDomainConfig();
const langGeoParam = addGeoParam();

const instance = axios.create({
  baseURL: (config.apiBaseUrl) ? config.apiBaseUrl + '/api' : '//' + window.location.hostname + '/api',
});

langGeoParam && instance.interceptors.request.use(config => {
  config.params = {
   geo: langGeoParam,
    ...config.params,
  };
  return config;
});

export default instance;